import { Component, h, Host, Prop } from '@stencil/core';

import { ClassNames } from '@/src/utils/interfaces';

@Component({
  tag: 'patternlib-slidercontrol',
  styleUrl: 'patternlib-slidercontrol.scss',
  shadow: true,
})
export class PatternlibSlidercontrol {
  /**
   * Define slider size.
   */
  @Prop() isCollapsed: boolean;

  /**
   * Set the label left.
   */
  @Prop() labelLeft = 'left';

  /**
   * Set the label right.
   */
  @Prop() labelRight = 'right';

  render() {
    const sliderRootClasses: ClassNames = {
      'slider-control-root': true,
      'slider-control-root--collapsed': this.isCollapsed,
    };

    const sliderLabelLeftClasses: ClassNames = {
      'slider-control-label': true,
      'slider-control-label-left': true,
    };

    const sliderLabelRightClasses: ClassNames = {
      'slider-control-label': true,
      'slider-control-label-right': true,
    };

    return (
      <Host>
        <div class={sliderRootClasses}>
          <div class={sliderLabelLeftClasses}>{this.labelLeft}</div>

          <patternlib-icon iconName="with-hand-to-wipe" color="var(--slider-control-icon-color)"></patternlib-icon>

          <div class={sliderLabelRightClasses}>{this.labelRight}</div>
        </div>
      </Host>
    );
  }
}
